<script setup lang="ts">
const props = defineProps<{
  hasActiveVerification: boolean;
  isVerified: boolean;
  onConfirm: () => Promise<void> | void;
  onCancel: () => void;
}>();

const { t } = useI18n();
const requestInProgress = ref(false);

function onDismiss() {
  if (requestInProgress.value) return;

  props.onCancel();
  useModal().close();
}

async function onConfirm() {
  if (requestInProgress.value) return;

  requestInProgress.value = true;

  try {
    await props.onConfirm();
    useModal().close();
  } finally {
    requestInProgress.value = false;
  }
}
</script>

<template>
  <CommonGenericModalContainer :prevent-close="requestInProgress">
    <template #header>
      <CommonGenericModalHeader
        title-key="common.warning"
        :on-dismiss="onDismiss"
        :disabled="requestInProgress"
      />
    </template>

    <div class="flex flex-col gap-4 leading-6 text-gray-700 dark:text-gray-200">
      <p v-if="props.hasActiveVerification">
        {{ t("verification.entity_edit_confirmation.active_verification") }}
      </p>

      <p v-if="props.isVerified">
        {{ t("verification.entity_edit_confirmation.verified_entity") }}
      </p>

      <p>
        {{ t("verification.entity_edit_confirmation.resubmit") }}
      </p>
    </div>

    <template #footer>
      <CommonGenericModalFooter>
        <UButton
          :label="t('common.cancel')"
          variant="link"
          :block="$device.isMobile"
          :disabled="requestInProgress"
          @click="onDismiss"
        />

        <UButton
          :label="t('verification.entity_edit_confirmation.confirm')"
          color="red"
          :block="$device.isMobile"
          :loading="requestInProgress"
          @click="onConfirm"
        />
      </CommonGenericModalFooter>
    </template>
  </CommonGenericModalContainer>
</template>
